import React from "react";
import InputComponent from "../input";


function BankingField(props){

    const fields = {
        name: "Банк",
        cardNumber: "Рахунок",
        note: "Примітка",
    }

    const w50 = ["note", "cardNumber"];

    return <div className={'d-flex flex-wrap pt-2'}>

        <small className={'text-secondary pt-2 opacity-50 w-100'}>#{props.id + 1}</small>

        {
            Object.keys(fields).map(key => <InputComponent
                key={key}
                id={props.id}
                type={'text'}
                name={key +'#' + props.id}
                value={props.value.key}
                onChange={(e) => props.onChange(props.id, e, key)}
                placeholder={fields[key]}
                class={`form-control rounded-0 border-0 border-bottom border-end ${w50.includes(key) ? "w-75" : "w-25"}`}
            />)
        }

        <button onClick={() => props.onRemove(props.id)}
                className={'btn btn-outline-danger rounded-0 w-25 text-uppercase'}>Видалить</button>

    </div>;
}

export default BankingField;
